module.exports = __webpack_public_path__ + "img/helpoutline.15739161.svg";